import { create } from '@terminal/utils/store/createStore';

export type CategoryType = 'all' | 'bookmarked' | 'scheduled';

interface HistorySidebarNavigationState {
  category: CategoryType;
  selectedScheduledQueryId: string | null;
}

interface HistorySidebarNavigationActions {
  setCategory: (category: CategoryType) => void;
  setSelectedScheduledQueryId: (id: string | null) => void;
}

type HistorySidebarNavigationStore = HistorySidebarNavigationState &
  HistorySidebarNavigationActions;

export const useHistorySidebarNavigation =
  create<HistorySidebarNavigationStore>(set => ({
    category: 'all',
    selectedScheduledQueryId: null,
    setCategory: category => set({ category }),
    setSelectedScheduledQueryId: id => set({ selectedScheduledQueryId: id }),
  }));
